import { useEffect, useState } from 'react';
import PatientDetailHead from './PatientDetailHead';
import SideMenue from './SideMenue';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import { useSelector } from 'react-redux';

function LayoutPatient({ children, patientId, handleHeaderData }) {
  const { user } = useSelector((state) => state.auth);
  const { globalReload } = useSelector((state) => state.app);

  const [allData, setAllData] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/patient/ProgressNote/hearderDetail', {
          patientId: patientId,
          staffUserId: user.id,
        });
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, globalReload, user.id]);

  useEffect(() => {
    handleHeaderData(allData);
  });
  return (
    <main>
      <div className="chart-main-con">
        <SideMenue patientId={patientId} allData={allData} />
        <div className="chart-right-col">
          <PatientDetailHead patientId={patientId} allData={allData} />
          {children}
        </div>
      </div>
    </main>
  );
}

export default LayoutPatient;
